import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Button, Card, Container, Stack, Typography, CircularProgress, FormControl, FormLabel, Select, MenuItem, TextField } from '@mui/material';
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarFilterButton } from '@mui/x-data-grid';
import moment from 'moment';
import { LoadingButton } from "@mui/lab";
import { useEffect, useState } from 'react';
import { CiExport } from "react-icons/ci";
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import DeleteModel from '../../components/Deletemodle';
import TableStyle from '../../components/TableStyle';
import { fetchPolicyData } from '../../redux/slice/policySlice';
import { apiget, deleteManyApi } from '../../service/api';
import { commonUtils } from '../../utils/utils';
// ----------------------------------------------------------------------


function CustomToolbar({ selectedRowIds, fetchPolicyData }, userRole) {
  const [opendelete, setOpendelete] = useState(false);
  const dispatch = useDispatch()

  const handleCloseDelete = () => {
    setOpendelete(false)
  }

  const handleOpenDelete = () => {
    setOpendelete(true)
  }

  const deleteManyContact = async (data) => {
    await deleteManyApi('api/policy/deletemany', data)
    dispatch(fetchPolicyData())
    handleCloseDelete();
  }

  return (
    <GridToolbarContainer>
      <Box padding={"10px 0"}>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector
          slotProps={{ tooltip: { title: 'Change density' } }}
        />

        {userRole !== "user" && (selectedRowIds && selectedRowIds.length > 0 && <Button variant="text" sx={{ textTransform: 'capitalize', fontSize: "13", padding: "4px 5px 2px  0", marginRight: "3px" }} startIcon={<DeleteIcon style={{ fontSize: '19px', marginLeft: "8px", marginBottom: "2px" }} />} onClick={handleOpenDelete}>Delete</Button>)}
      </Box>
      <DeleteModel opendelete={opendelete} handleClosedelete={handleCloseDelete} deletedata={deleteManyContact} id={selectedRowIds} />
    </GridToolbarContainer>
  );
}


const Policy = () => {

  const [policyList, setPolicyList] = useState([]);
  const [field, setField] = useState('policyStartDate');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [userAction, setUserAction] = useState(null)
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const userid = sessionStorage.getItem('user_id')
  const userRole = sessionStorage.getItem("userRole")


  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleSelectionChange = (selectionModel) => {
    setSelectedRowIds(selectionModel);
  };
  
  const fetchPolicies = async () => {
    setIsLoading(true);
    const response = await apiget(`api/policy/`);
    console.log(response);
    setPolicyList(response?.data?.result)
    setIsLoading(false);
  }

  const filterPolicyData = async () => {
    setIsLoading(true);
    const filteredPolicies = policyList.filter(item => {
      const start = new Date(startDate)
      const end = new Date(endDate)
      const d = new Date(item[field])
      return d >= start && d <= end
     })
    setPolicyList(filteredPolicies)
    setIsLoading(false);
  }

  const columns = [
    {
      field: "policyNumber",
      headerName: "Policy Number",
      width: 100,
      cellClassName: "name-column--cell",
      renderCell: (params) => {
        const handleFirstNameClick = () => {
          navigate(`/dashboard/policy/view/${params.id}`)
        };

        return (
          <Box onClick={handleFirstNameClick}>
            {params.value}
          </Box>
        );
      }
    },
    {
      field: "policyType",
      headerName: "Policy Type",
      width: 300,
    },
    {
      field: "insuredPersonName",
      headerName: "Insured",
      width: 300,
    },
    {
      field: "vehicleRegistrationNumber",
      headerName: "Vehicle Registration",
      width: 200,
    },
    {
      field: "phoneNumber",
      headerName: "Phone Number",
      width: 200,
    },
    {
      field: "policyStartDate",
      headerName: "Policy Start Date",
      width: 200,
      valueFormatter: (params) => {
        const date = new Date(params.value);
        return date.toDateString();
      },
    },
    {
      field: "policyEndDate",
      headerName: "Policy End Date",
      width: 200,
      valueFormatter: (params) => {
        const date = new Date(params.value);
        return date.toDateString();
      },
    },
    {
      field: "policyStatus",
      headerName: "Policy Status",
      width: 200,
    },
    {
      field: "commission",
      headerName: "Commission Earned",
      width: 200,
    },
    {
      field: "creator",
      headerName: "Issued By",
      width: 300,
    }
  ];

  const csvColumns = [
    { Header: "Policy Number", accessor: 'policyNumber' },
    { Header: "Policy Type", accessor: 'policyType' },
    { Header: "Insured", accessor: "insuredPersonName" },
    { Header: "Vehicle Registration", accessor: "vehicleRegistrationNumber" },
    { Header: "Phone Number", accessor: "phoneNumber" },
    { Header: "Policy Start Date", accessor: 'policyStartDate', type: 'date' },
    { Header: "Policy End Date", accessor: 'policyEndDate', type: 'date' },
    { Header: "Policy Status", accessor: 'policyStatus' },
    { Header: "Commission Earned", accessor: 'commission' },
    { Header: "Issued By", accessor: 'creator' },
  ];

  const downloadCsvOrExcel = async (extension, selectedIds) => {
    const formatDateOfBirth = (dateString, filednm) => {
      return moment(dateString).format('DD/MM/YYYY HH:MM A')
    };

    const formatRecords = (records) => {
      return records.map((rec) => {
        const selectedFieldsData = {};
        csvColumns?.forEach((item) => {
          if (item?.type === 'date') {
            selectedFieldsData[item?.accessor] = formatDateOfBirth(rec[item?.accessor]);
          }
          else {
            selectedFieldsData[item?.accessor] = rec[item?.accessor];
          }
        });
        return selectedFieldsData;
      });
    };

    if (selectedIds && selectedIds?.length > 0) {
      const selectedRecordsWithSpecificFileds = formatRecords(policyList?.filter((rec) => selectedIds?.includes(rec._id)));
      commonUtils.convertJsonToCsvOrExcel({ jsonArray: selectedRecordsWithSpecificFileds, csvColumns, fileName: "Policy", extension, setSelectedRowIds });
    } else {
      const AllRecordsWithSpecificFileds = formatRecords(policyList);
      commonUtils.convertJsonToCsvOrExcel({ jsonArray: AllRecordsWithSpecificFileds, csvColumns, fileName: "Policy", extension, setSelectedRowIds });
    }
  };
  const handleExportPolicy = (extension) => {
    if (selectedRowIds && selectedRowIds?.length > 0) {
      downloadCsvOrExcel(extension, selectedRowIds)
    } else {
      downloadCsvOrExcel(extension);
    }
  };

  useEffect(() => {
    dispatch(fetchPolicyData());
    fetchPolicies()
  }, [userAction])

  return (
    <>
      {/* Add Lead Model */}
      <Container maxWidth>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" >
            Policy
          </Typography>
          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
            <Button variant="contained" startIcon={<CiExport icon="eva:plus-fill" />} onClick={() => { handleClose(); handleExportPolicy('xlsx') }}>
              {selectedRowIds && selectedRowIds?.length > 0 ? 'Export Selected Data' : 'Export'}
            </Button>
          </Stack>
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent={"space-between"} mb={5}>
          <FormControl>
            <FormLabel>Column Name</FormLabel>
              <Select
              labelId="demo-simple-select-label"
              id="field"
              name="field"
              label=""
              size='small'
              fullWidth
              value={field}
              onChange={(e) => {
                setField(e.target.value);
              }}
              >
              <MenuItem value="policyStartDate">Policy Start Date</MenuItem>
              <MenuItem value="policyEndDate">Policy Expiry Date</MenuItem>
              </Select>
          </FormControl>
          <FormControl>
            <FormLabel>Start Date</FormLabel>
            <TextField
                id="start_date"
                name="start_date"
                type='date'
                size='small'
                fullWidth
                value={startDate}
                onChange={(e) => {
                  setStartDate(e.target.value);
                }}
            />
            </FormControl>
            <FormControl>
              <FormLabel>End Date</FormLabel>
                <TextField
                    id="end_date"
                    name="end_date"
                    type='date'
                    size='small'
                    fullWidth
                    value={endDate}
                    onChange={(e) => {
                      setEndDate(e.target.value);
                  }}
                />
            </FormControl>
          <LoadingButton onClick={filterPolicyData} variant='contained' color='secondary' disabled={!!isLoading}>
              {isLoading ? <CircularProgress size={27} /> : 'FILTER'}
          </LoadingButton>
          <LoadingButton onClick={fetchPolicies} variant='contained' color='secondary' disabled={!!isLoading}>
              {isLoading ? <CircularProgress size={27} /> : 'REFRESH'}
          </LoadingButton>
        </Stack>
        <TableStyle>
          <Box width="100%">
            {isLoading ? (
              <Card style={{ display: 'flex', justifyContent: 'center', height: "600px" }}>
                <span className="loader" />
              </Card>
            ) : (
              <Card style={{ height: "600px" }}>
                <DataGrid
                  rows={policyList || []}
                  columns={columns}
                  components={{ Toolbar: () => CustomToolbar({ selectedRowIds, fetchPolicyData }, userRole) }}
                  checkboxSelection
                  onRowSelectionModelChange={handleSelectionChange}
                  rowSelectionModel={selectedRowIds}
                  getRowId={row => row._id}
                />
              </Card>
            )}


          </Box>
        </TableStyle>
      </Container>
    </>
  );
}

export default Policy